export default "__VITE_ASSET__CuY2ZhHH__"